import React from 'react';
import { CheckBox } from '../../Common';
import { Grid, Typography, Paper, Chip, Divider, Box } from '@mui/material';
import { Grey1 } from "../../../color_utils";
import { systemRowPaperProps } from './styles';

const SystemRow = ({ asset, isChecked, onCheck, disabled, loading, chipLabel, chipColor, inventoryData, children }) => (
    <Grid container sx={{ ml: { xs: 0, md: 2 }, px: { xs: 2, md: 0 } }}>
        <Grid item xs={"auto"}>
            <CheckBox
                checked={isChecked}
                onChange={onCheck}
                disabled={disabled || loading}
                labelStyle={{ mr: 0 }}
            />
        </Grid>

        <Grid item xs>
            <Paper
                variant="outlined"
                sx={{
                    ...systemRowPaperProps,
                    ...((disabled || loading) && { backgroundColor: "#f5f5f5", opacity: 0.7 })
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                pr: 2,
                                pt: 1.5,
                                pb: 0,
                            }}
                        >
                            <Typography variant="body1" color={Grey1} sx={{ fontSize: "18px", fontWeight: "bold" }}>
                                {asset.name}
                            </Typography>
                            <Chip
                                label={chipLabel}
                                sx={{ color: "#FFF", backgroundColor: chipColor, mr: { xs: 0, md: 2 } }}
                            />
                        </Box>
                    </Grid>
                    {inventoryData.map(({ label, value }, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    sx={{ fontWeight: "bold" }}
                                >
                                    {label.toUpperCase()}:
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    {value}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                    <Grid item xs={12}>
                        <Divider component="div" />
                    </Grid>
                    {children}
                </Grid>
            </Paper>
        </Grid>
    </Grid>
);

export default SystemRow;
